import React, { useEffect, useState } from "react";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import HeadingText from "components/common/HeadingText/HeadingText";
import { Container, Form, Row, Col } from "reactstrap";
import ButtonComponent from "components/common/Button/ButtonComponent";
import LoaderComponent from "components/common/Loader/Loader";
import Toaster from "components/common/Toaster/Toaster";
import { normalizeWarehouseResponseForDropdown } from "normalizer/ShipperNormalizer";
import { Can } from "config/Can";
import { DATE_FORMAT, PLAN_CREATION_OPTIONS,CUSTOMER_CHANNEL_OPTIONS, CHANNEL_TO_STORE_TYPE_MAP } from "config/constants";
import {
  IPlanCreationPageProps,
  IPlanCreationState,
  IWarehousePayload,
  IMultiSelectOption,
} from "interfaces/Index";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { format } from "date-fns";
import fileDownload from "js-file-download";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import TextField from "components/common/TextField/TextField";
import MultiSelectDropDown from "components/common/MultiSelectDropDown/MultiSelectDropDown";
import { normalizeLocusCsvPayload } from "normalizer/RiderManagementNormalizer";
import PlanOutputSection from "./PlanOutputSection/PlanOutputSection";

const headingText = "Plan Creation";
const buttonText = "Download Plan";

const PlanCreationPage: React.FunctionComponent<IPlanCreationPageProps> = (
  props
) => {
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [planCreation, setPlanCreation] = useState<IPlanCreationState>(
    props.dummyPlanCreationData || {
      warehouseId: "",
      targetDate: new Date().toString(),
      planType: [],
      customerChannel: [],
      storeType: []
    }
  );

  const [storeTypes, setStoreTypes] = useState<IMultiSelectOption[]>([])

  useEffect(() => {
    const { getWarehouseNamesForPlanCreation } = props;
    getWarehouseNamesForPlanCreation();
  }, []);

  useEffect(() => {
    const { isCsvDownloaded, locusCsvFile } = props;
    if (isCsvDownloaded) {
      fileDownload(
        locusCsvFile,
        `locus-data-dump${format(Date.now(), DATE_FORMAT.DATE_TIME)}.csv`
      );
      const message = "Plan For Locus created successfully!";
      handleToaster(false, message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [props.isCsvDownloaded]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  const handleSearchableSelect = (e: IWarehousePayload, fieldId: string) => {
    setPlanCreation({
      ...planCreation,
      [fieldId]: e,
    });
  };

  const validateForm =
    props.dummyValidation ||
    !!(
      planCreation.warehouseId &&
      planCreation.planType.length > 0 &&
      planCreation.targetDate
    );

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleSubmit = () => {
    const { downloadLocusCsv } = props;
    let locusPayload = normalizeLocusCsvPayload(planCreation);
    downloadLocusCsv(locusPayload);
  };

  const handleTargetDate = (value: any) => {
    setPlanCreation({
      ...planCreation,
      targetDate: value,
    });
  };

  const handleMultiselectChange = (fieldId: string) => (values: IMultiSelectOption[]) => {
    setPlanCreation({
      ...planCreation,
      [fieldId]: values,
    });
  };

  const handleCustomerChannelSelection = (values: IMultiSelectOption[]) => {
    //get storeType
    const storeTypes = getUniqueStoreTypesByChannels(values.map(it=>it.value))

    const storeTypeOptions = storeTypes.map(it => ({id: it, label: it, value: it}))

    setStoreTypes(storeTypeOptions)

    setPlanCreation({
      ...planCreation,
      customerChannel: values,
      storeType: []
    });
    
  }
  function getUniqueStoreTypesByChannels(channels:string[]) {

    const storeTypes = channels.flatMap(channel => CHANNEL_TO_STORE_TYPE_MAP[channel] || [])

    return storeTypes;
  }

  // function getStoreTypesByChannels(channels:string[]) {
  //   console.log(typeof CHANNEL_TO_STORE_TYPE_MAP)
  //   const result = [];
    
  //   for (const channel of channels) {
  //     // Only add store types if the channel exists in the object
  //     if (CHANNEL_TO_STORE_TYPE_MAP[channel]) {
  //       // Push all store types from this channel
  //       result.push(...channelToStoreTypes[channel]);
  //     }
  //   }
    
  //   return result;
  // }
  


  
  const renderFormButton = () => {
    return (
      <Can I="create" a="plan">
        <Row>
          <Col lg="6">
            <ButtonComponent
              buttonClass="large-button btn-primary"
              buttonText={buttonText}
              onClickHandler={handleSubmit}
              isDisable={props.isLoading || !validateForm}
            />
          </Col>
        </Row>
      </Can>
    );
  };
  const renderPlanDetails = () => {
    return (
      <FormSectionLayout subTitleText="Plan Details">
        <section className="form-group search-container">
          <MultiSelectDropDown
            options={PLAN_CREATION_OPTIONS}
            label="Select Task Type"
            selectedValues={planCreation.planType}
            placeholder={"Please select task type"}
            displayValue="label"
            onChange={handleMultiselectChange("planType")}
            onRemove={handleMultiselectChange("planType")}
          />
          <SearchableSelect
            id="warehouseId"
            isSearchable={true}
            options={normalizeWarehouseResponseForDropdown(
              props.wareHouseNames
            )}
            onChange={(e: any) => {
              handleSearchableSelect(e, "warehouseId");
            }}
            label="Select warehouse"
            placeholder="Please select warehouse"
            selectedValue={planCreation.warehouseId}
          />
          <Row>
            <Col lg="6" className="drop">
              <DatePicker
                selected={new Date(planCreation.targetDate)}
                dateFormat={DATE_FORMAT.ddMMyyyy}
                id="targetDate"
                onChange={handleTargetDate}
                customInput={
                  <TextField
                    id="targetDate"
                    label="Target Date"
                    value={planCreation.targetDate}
                    placeholder={""}
                  />
                }
              />
            </Col>
          </Row>
          <MultiSelectDropDown
            options={CUSTOMER_CHANNEL_OPTIONS}
            label="Select Customer Channel"
            selectedValues={planCreation.customerChannel}
            placeholder={"Please select Customer Channels"}
            displayValue="label"
            onChange={handleCustomerChannelSelection}
            onRemove={handleCustomerChannelSelection}
          />
          <MultiSelectDropDown
            options={storeTypes}
            label="Select Store Type"
            selectedValues={planCreation.storeType}
            placeholder={"Please select Store Type"}
            displayValue="label"
            onChange={handleMultiselectChange("storeType")}
            onRemove={handleMultiselectChange("storeType")}
          />     
          <section className="form-row-separator">{renderFormButton()}</section>
        </section>
      </FormSectionLayout>
    );
  };

  return (
    <Container fluid className="tour-creation-container">
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row className="tour-assignment-heading">
        <Col lg="6">
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="">{renderPlanDetails()}</div>
            <PlanOutputSection
              downloadPlanOutputCsv={props.downloadPlanOutputCsv}
              isLoading={props.isLoading}
            />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

PlanCreationPage.defaultProps = {
  dummyValidation: false,
  dummyPlanCreationData: null,
};

export default PlanCreationPage;
